import { PluginFunc } from 'dayjs';

export const toServerDateTimeFormat: PluginFunc = (option, dayjsClass, dayjsFactory) => {
  (dayjsClass as any).prototype.toServerDateTimeFormat = function () {
    return this.format('YYYY-MM-DDTHH:mm:ss.sss');
  };
};
